import { Stop } from "@/types/collections"

/** A haulage delivery is the only stop type that earns revenue, and it is stored on the stop. */
export const isHaulageDelivery = (stop: Stop): boolean =>
  stop.slotType === "haulage_delivery" ||
  (stop as unknown as { stop_type?: string }).stop_type === "haulage_delivery"

/** A direct injection is the only stop type that carries a price, also stored on the stop. */
export const isDirectInjection = (stop: Stop): boolean =>
  stop.slotType === "direct_injection" ||
  (stop as unknown as { stop_type?: string }).stop_type === "direct_injection"
